import { z } from 'zod';
import { IdentityPlatform } from '@playcastdotio/CoreTypes';
export enum ClientType {
  HOST = 'HOST',
  PLAYER = 'PLAYER',
  REMOTE_CLIENT = 'REMOTE_CLIENT',
  REMOTE_HOST = 'REMOTE_HOST',
  OBSERVER = 'OBSERVER',
  SERVICE = 'SERVICE',
  ADMIN = 'ADMIN',
}

export const clientTypeSchema = z.nativeEnum(ClientType);

// Common profile schema used across modules
export const profileSchema = z.object({
  displayName: z.string().optional(),
  bio: z.string().optional(),
  avatarUrl: z.string().optional(),
  bannerUrl: z.string().optional(),
  selectedAliasPlatform: z.nativeEnum(IdentityPlatform).optional(),
  socialLinks: z.record(z.string()).optional(),
});

export type Profile = z.infer<typeof profileSchema>;

export const matchmakingPreferencesSchema = z.object({});

export const matchmakingPlayerSchema = z.object({
  playerId: z.string().optional(),
  displayName: z.string(),
  preferences: matchmakingPreferencesSchema.optional(),
  geohash: z.string().optional(), // NEW: Player's L3 geohash (3-char, ~97mi precision)
});
